<template>
    <div class="bg-light" style="min-height: 100vh; margin-bottom: 50px">
        <vue-navbar />

        <slot name="header">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <hr class="mt-10" />

                        <nav class="align-items-center mb-0 pt-3 pb-1" aria-label="breadcrumb">
                            <div class="float-right w-100 w-md-auto mt-4 mt-md-0">
                                <vue-select-input
                                    :data="clients"
                                    :loading="loading.clients"
                                    :data-value="(item) => item.id"
                                    :data-text="(item) => item.name"
                                    placeholder="Select a client"
                                    v-model="selectedClient"
                                    v-on:change="updateClient"
                                />
                            </div>

                            <vue-breadcrumbs />
                        </nav>
                    </div>
                </div>
                <div class="mx-auto pt-12 text-center" v-if="hasTitle">
                    <h1 class="display-2 mb-5">
                        <portal-target name="title" slim />
                    </h1>
                </div>
                <portal-target name="actions" />
            </div>
        </slot>

        <div class="container" style="margin-bottom: 64px">
            <router-view />
        </div>

        <vue-footer />
    </div>
</template>

<script>
    import Vue from 'vue';

    import VueNavbar from '@components/navbar';
    import VueFooter from '@components/footer';
    import VueBreadcrumbs from '@components/breadcrumbs';
    import VueSelectInput from '@components/selectInput';
    import { Wormhole } from 'portal-vue';

    import clientsService from '@api/clients';

    export default Vue.extend({
        components: {
            VueNavbar,
            VueBreadcrumbs,
            VueFooter,
            VueSelectInput
        },
        data() {
            return {
                clients: [],
                selectedClient: 1,
                loading: {
                    clients: true
                }
            };
        },
        computed: {
            hasTitle() {
                return Wormhole.hasContentFor('title');
            }
        },
        methods: {
            fetchClients() {
                this.loading.clients = true;

                clientsService
                    .index()
                    .then((response) => {
                        this.clients = response.data.clients;
                        this.selectedClient = response.data.selected_client;

                        if (!this.selectedClient) {
                            window.location.reload();
                        }
                    })
                    .catch((error) => {
                        window.location.href = `/error/${error.response.status}`;
                    })
                    .finally(() => {
                        this.loading.clients = false;
                    });
            },
            updateClient() {
                if(!this.selectedClient) {
                    return;
                }

                clientsService
                    .set(this.selectedClient)
                    .then(() => {
                        window.location.href = '/enquiries';
                    })
                    .catch((error) => {
                        window.location.href = `/error/${error.response.status}`;
                    });
            }
        },
        mounted() {
            this.fetchClients();
        }
    });
</script>
